<div class="exchange-currency" [ngStyle]="contentStyle">
  <form
    [formGroup]="exchangeCurrencyForm"
    class="finxForm"
    [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
  >
    <div>
      <div>
        <ng-template #customSellCurrencyOption let-sellCurrencyOption>
          <span class="d-inline-flex gap-2 w-100">
            @if (showFlags) {
              <span class="d-contents" [innerHTML]="sellCurrencyOption.currencyFlag | safeHtml"></span>
            }
            <div
              class="w-100"
              [innerHTML]="createSellCurrencyItemTemplate(sellCurrencyOption) | safeHtml"
            ></div>
          </span>
        </ng-template>

        <ng-template #customSellCurrencySelectedOption>
          @if (defaultSellAccount && renderedSelectedSellCurrencyContent) {
            <span class="d-inline-flex gap-2 w-100">
              @if (showFlags) {
                <span
                  class="d-contents"
                  [innerHTML]="defaultSellAccount?.currencyFlag ?? '' | safeHtml"
                ></span>
              }
              <div class="w-100" [innerHTML]="renderedSelectedSellCurrencyContent | safeHtml"></div>
            </span>
          } @else {
            <span class="placeholder">{{ currencyDropdownPlaceholder }}</span>
          }
        </ng-template>
        <finxone-select-dropdown
          id="sellAccountId"
          formControlName="sellAccountId"
          [options]="sellAccountList"
          [customOptionTemplate]="customSellCurrencyOption"
          [customSelectedOptionTemplate]="customSellCurrencySelectedOption"
          [optionLabelKey]="'title'"
          [optionValueKey]="'key'"
          [appendToBody]="true"
          [selectedOption]="defaultSellAccount?.key ?? ''"
          [label]="widgetConfig.attributes.widgetProperties.inputFieldSettings?.sellAccountLabel ?? ''"
          (selectionChange)="onSelectionChange('Sell')"
        >
        </finxone-select-dropdown>
      </div>
    </div>

    <div>
      <ng-template #customBuyCurrencyOption let-buyCurrencyOption>
        <span class="d-inline-flex gap-2 w-100">
          @if (showFlags) {
            <span class="d-contents" [innerHTML]="buyCurrencyOption.currencyFlag | safeHtml"></span>
          }
          <div class="w-100" [innerHTML]="createBuyCurrencyItemTemplate(buyCurrencyOption) | safeHtml"></div>
        </span>
      </ng-template>

      <ng-template #customBuyCurrencySelectedOption>
        @if (defaultBuyAccount && renderedSelectedBuyCurrencyContent) {
          <span class="d-inline-flex gap-2 w-100">
            @if (showFlags) {
              <span class="d-contents" [innerHTML]="defaultBuyAccount?.currencyFlag ?? '' | safeHtml"></span>
            }
            <div class="w-100" [innerHTML]="renderedSelectedBuyCurrencyContent | safeHtml"></div>
          </span>
        } @else {
          <span class="placeholder">{{ currencyDropdownPlaceholder }}</span>
        }
      </ng-template>

      <finxone-select-dropdown
        id="buyAccountId"
        formControlName="buyAccountId"
        [options]="buyAccountList"
        [customOptionTemplate]="customBuyCurrencyOption"
        [customSelectedOptionTemplate]="customBuyCurrencySelectedOption"
        [optionLabelKey]="'title'"
        [optionValueKey]="'key'"
        [appendToBody]="true"
        [selectedOption]="defaultBuyAccount?.key ?? ''"
        [label]="widgetConfig.attributes.widgetProperties.inputFieldSettings?.buyAccountLabel ?? ''"
        (selectionChange)="onSelectionChange('Buy')"
      >
      </finxone-select-dropdown>
    </div>
    <div>
      <finxone-input
        [type]="'number'"
        [name]="'amount'"
        [label]="widgetConfig.attributes.widgetProperties.inputFieldSettings?.amountInputLabel ?? ''"
        formControlName="amount"
        [placeholder]="currencySymbol"
        [formControlInvalid]="
          !!(
            exchangeCurrencyForm.controls['amount']?.invalid &&
            exchangeCurrencyForm.controls['amount']?.touched
          )
        "
        [value]="exchangeCurrencyForm.controls['amount']?.value ?? ''"
        [validationConfig]="[
          {
            type: 'required',
            message: 'Amount is mandatory',
          },
        ]"
      >
      </finxone-input>
    </div>
    <div>
      <finx-button
        type="button"
        (click)="onSubmit()"
        [labeltext]="renderedContent"
        class="quote-button pointer-events-none d-flex"
        [class.h-100]="!isAllowedGlobalStyling"
        [buttonStyle]="!isAllowedGlobalStyling ? quoteButtonStyle : {}"
        [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100 mandatory-cta-button'"
        [isAllowedGlobalStyling]="isAllowedGlobalStyling"
        [disabled]="!exchangeCurrencyForm.valid"
        [class.disabled-class]="!exchangeCurrencyForm.valid"
      ></finx-button>
    </div>
  </form>
</div>
